import {REQUEST_SUCCESS} from '../../middlewares/api/actions';
import {CONFIG_READ} from './actions';

const configReducer = (
  state = {
    nodes: [],
    userInterface: {
      defaultTableRows: null,
      maxTableRows: null,
      defaultSidebarCollapsed: null,
      isSidebarMenuExpanded : null,
      defaultLanguage: null,
      languages: [],
      anonymousPages: [],
      minTreeNodesForPagination: null,
      maxTreeNodesForPagination: null,
      treePageSize: null
    },
    dataManagement: {
      cubeCodePrefix: null,
      datasetPrefix: null,
      dataLanguages: [],
      maxDescriptionLength: null
    }
  },
  action
) => {
  switch (action.type) {
    case REQUEST_SUCCESS:
      switch (action.label) {
        case CONFIG_READ:
          return action.response;
        default:
          return state;
      }
    default:
      return state;
  }
};

export default configReducer;
